import React from "react";
import styled from "styled-components";
import ToolGroup from "./toolGroup";
import logger from "utils/logger";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



const StyledGridTableRow = styled.tr`
  &:nth-child(odd) {
    background-color: #f9f9f9;
  }

  &:nth-child(even) {
    background-color: #fff;
  }

  &:hover {
    background-color: #f5f5f5;
  }

  cursor: ${({ cursor }) => cursor};
`;

const StyledTd = styled.td`
  border: 1px solid ${({ theme }) => theme.weakGray};
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  color: ${({ theme }) => theme.black};
  font-size: ${({ theme }) => theme.fontSize.nomal};
  font-size: 15px;
`;

const UploadFilesTableRow = ({
  auth,
  item = {},
  paths = [],
  tools,
  showTools,
  cursor = "unset",
  icon, // 当前这一行所对应的图标和状态
  position, //当前是第几行
  files
}) => {

  const result = files.zipFileShow.filter( (item) => {
    return item.name === files.jsonContentShow[position]?.fileName + '.zip'
  })
  return (
    <StyledGridTableRow cursor={cursor} title={result[0]?.name}>
      {paths.map((path, index) => (
        path === 'status' 
          ? (<StyledTd key={index}>
               {icon.status.length === 0 ? (<FontAwesomeIcon icon={icon.icon[0]} title={icon.title[0]}/>) :(<FontAwesomeIcon icon={icon.icon[icon.status[position]]} title={icon.title[icon.status[position]]}/>)}
            </StyledTd>)
          : (<StyledTd key={index}>{item[path]}</StyledTd>)
      ))}
      {tools && showTools && (
        <StyledTd>
          <ToolGroup tools={tools} auth={auth} data={item} />
        </StyledTd>
      )}
    </StyledGridTableRow>
  );
};

export default UploadFilesTableRow;
